// Any new action should be added here and added into ALLOWED_ACTIONS and ACTIONS_OPTIONS
const summarize_text = 'summarize_text';
const expand_text = 'expand_text';
const grammar_check = 'grammar_check';
const change_tone = 'change_tone';
const revise_text = 'revise_text';
const generate_job_post_description = 'generate_job_post_description';

// Build out groupings of actions here for specific use-cases, then set them up in ai_action_consts.ts
export const JOB_POST_ACTIONS = Object.freeze([change_tone, grammar_check]);

export const EMAIL_ACTIONS = Object.freeze([
  change_tone,
  summarize_text,
  expand_text,
  grammar_check,
  revise_text,
]);

export const ALLOWED_ACTIONS = Object.freeze([
  summarize_text,
  expand_text,
  grammar_check,
  change_tone,
  revise_text,
  generate_job_post_description,
]);

export const ACTIONS_OPTIONS = Object.freeze({
  summarize_text,
  expand_text,
  change_tone,
  grammar_check,
  revise_text,
  generate_job_post_description,
});

export const ALLOWED_TONES = Object.freeze([
  'friendly',
  'professional',
  'enthusiastic',
  'formal',
  'concise',
  'informative',
]);

// eslint-disable-next-line no-shadow
export const enum AI_PRODUCT {
  GHSA = 'ghsa',
  CANDIDATE_PROFILE_EMAIL = 'candidate_profile_email',
  JOB_KICKOFF = 'job_kickoff',
  STAGE_TRANSITION_RULES = 'stage_transition_rules',
  JOB_POST = 'draft_job_posts',
}
